import { inject, Injectable, DOCUMENT } from '@angular/core';

import { Store } from '@ngrx/store';

import { ThemeCssObj, ThemeService } from '@resident-nx/shared';
import { ImmomioThemeService } from '@immomio/ui/theme';

@Injectable({
  providedIn: 'root',
})
export class ThemeWebService extends ThemeService {
  #document = inject(DOCUMENT);
  #immomioThemeService = inject(ImmomioThemeService);

  constructor() {
    super(inject(Store));
  }

  protected applyTheme(themeObj: ThemeCssObj): void {
    Object.keys(themeObj).map(key =>
      this.#document.body.style.setProperty(`${key}`, themeObj[key])
    );
    const theme = {
      primaryColor: themeObj['--color-primary'],
      secondaryColor: themeObj['--color-secondary'],
      primaryTextColor: themeObj['--color-text-primary'],
      secondaryTextColor: themeObj['--color-text-secondary'],
      backgroundColor: themeObj['--color-background-medium'],
      containerBackgroundColor: themeObj['--color-surface'],
    };

    this.#immomioThemeService.setTheme(theme);
  }
}
